const { createSlice } = require('@reduxjs/toolkit');
const mainCollectionProductSlice = createSlice({
    name: 'mainCollectionProduct',
    initialState: {
        products: [],
    },
    reducers: {
        setmainCollectionProducts(state, action) {
            state.products = action.payload;
        }
    },
});
export const { setmainCollectionProducts } = mainCollectionProductSlice.actions;
export default mainCollectionProductSlice.reducer;